export type BonusIcon = 'book' | 'prayer' | 'calendar' | 'heart' | 'cards';
export type Bonus = {
  number: number;
  title: string;
  description: string;
  image: string;
  icon: BonusIcon;
  highlight?: string;
};
export type Step = {
  title: string;
  description: string;
};
export type Faq = {
  question: string;
  answer: string;
};
export type CollectionItem = {
  title: string;
  kind: 'principal' | 'bono';
};
export const checkoutUrl = 'https://desafio-mujer-de-proverbios-31.impultienda.ar/checkout';
export const offer = {
  price: '$9,90',
  note: 'Pago único'
};

// Imágenes oficiales. El producto principal es el mockup de la mujer sosteniendo el material.
export const images = {
  bundle: 'https://cdn.magicpatterns.com/uploads/vZ2DNLxekpVciV1ZgsJnd8/ChatGPT_Image_25_sept_2026,_10_59_23_a.m..png',
  bundleAlt: 'Colección completa: Desafío Mujer de Proverbios 31, Planificador de Mayordomía Cristiana, Devocional, Oraciones Diarias, Botiquín Espiritual y 50 Tarjetas de Promesas Bíblicas',
  main: 'https://cdn.magicpatterns.com/uploads/cnxY15buEy9ZAoNMRGwFzy/ChatGPT_Image_24_sept_2026,_08_12_30_p.m..png',
  mainAlt: 'Mujer sosteniendo el material “31 Días para ser la Mujer de Proverbios 31” junto a una Biblia abierta y una taza',
  devocional: 'https://cdn.magicpatterns.com/uploads/4kGZrmNUCEhwiewLNz3ShF/ChatGPT_Image_24_sept_2026,_07_11_17_p.m..png',
  planificador: 'https://cdn.magicpatterns.com/uploads/jREM2FRk5bTAerr6yxjiGY/ChatGPT_Image_25_sept_2026,_10_53_44_a.m..png',
  botiquin: 'https://cdn.magicpatterns.com/uploads/cSZBWnRLQyKyFXsC11udqS/ChatGPT_Image_24_sept_2026,_07_53_21_p.m..png',
  oraciones: 'https://cdn.magicpatterns.com/uploads/qTN3qhotgF9nnKfbusZ9De/mockup-oraciones-diarias.png',
  promesas: 'https://cdn.magicpatterns.com/uploads/hKQnimhXZmcdf3xKXDp1R7/ChatGPT_Image_25_sept_2026,_10_10_59_a.m..png'
};
export const hero = {
  eyebrow: 'Desafío Mujer de Proverbios 31',
  subtitle: '31 días para llevar tu fe a la práctica y cultivar, paso a paso, las virtudes de la mujer que Dios te llamó a ser.',
  stats: ['Días', 'Enseñanzas', 'Oraciones', 'Acciones'],
  checks: ['Acceso digital', 'Pago único', 'Comienza hoy mismo'],
  cta: 'QUIERO COMENZAR MI DESAFÍO'
};
export const identification = {
  headline: 'Amas a Dios y quieres crecer en tu fe…',
  headlineAccent: 'pero a veces la rutina te gana.',
  situations: ['Quieres dedicarle más tiempo a Dios, pero lo vas postergando.', 'Empiezas nuevas rutinas espirituales con entusiasmo y después te cuesta sostenerlas.', 'Lees la Biblia, pero a veces no sabes cómo llevar lo aprendido a tu día a día.', 'Quieres crecer en sabiduría, carácter y propósito.', 'Admiras las virtudes de la Mujer de Proverbios 31, pero no sabes por dónde empezar a cultivarlas.'],
  hope: 'Si te reconociste en estas palabras, hay un camino sencillo para empezar.'
};
export const opportunity = {
  quote: 'Quizás no necesitas leer más sobre la mujer que quieres ser.',
  quoteAccent: 'Necesitas empezar a practicarlo.',
  body: ['Leer Proverbios 31 puede inspirarte.', 'Pero llevar esas enseñanzas a tu forma de hablar, decidir, servir, agradecer, relacionarte y vivir tu fe es lo que permite comenzar a convertirlas en parte de tu vida cotidiana.'],
  closing: ['No se trata de cambiar toda tu vida de un día para otro.', 'Se trata de elegir una pequeña forma de crecer cada día.', 'Durante 31 días.']
};
export const steps: Step[] = [{
  title: 'Palabra',
  description: 'Una enseñanza bíblica para guiar tu día.'
}, {
  title: 'Reflexión',
  description: 'Un momento para comprender cómo esa enseñanza se relaciona con tu vida.'
}, {
  title: 'Oración',
  description: 'Un espacio para llevar delante de Dios aquello que estás viviendo.'
}, {
  title: 'Acción',
  description: 'Una pequeña acción para que lo aprendido no quede solamente en una lectura.'
}];
export const stepsTagline = ['Una enseñanza.', 'Una oración.', 'Una pequeña acción.', 'Un día a la vez.'];
export const mainProduct = {
  subtitle: '31 días para convertir la inspiración de Proverbios 31 en pequeñas acciones cotidianas.',
  intro: 'Durante el recorrido encontrarás acciones relacionadas con áreas como:',
  areas: ['Fe', 'Palabras', 'Gratitud', 'Relaciones', 'Servicio', 'Descanso', 'Propósito', 'Carácter', 'Hogar', 'Tiempo con Dios']
};
export const bonuses: Bonus[] = [{
  number: 1,
  title: 'Devocional Mujer de Proverbios 31',
  description: '31 días de reflexiones bíblicas para profundizar en la Palabra, trabajar tu carácter y aplicar cada enseñanza a tu vida.',
  image: images.devocional,
  icon: 'book'
}, {
  number: 2,
  title: 'Oraciones Diarias',
  description: '31 días de oraciones guiadas para acompañarte en diferentes momentos y ayudarte a poner delante de Dios aquello que estás viviendo.',
  image: images.oraciones,
  icon: 'prayer'
}, {
  number: 3,
  title: 'Planificador de Mayordomía Cristiana',
  description: "Un planificador creado para ayudarte a organizar con mayor intención tu tiempo, responsabilidades, hábitos, recursos y vida espiritual.",
  image: images.planificador,
  icon: 'calendar',
  highlight: '142 páginas'
}, {
  number: 4,
  title: 'Botiquín Espiritual para la Mujer Virtuosa',
  description: 'Un recurso para esos momentos en los que necesitas una palabra de Dios. Incluye versículos, reflexiones, oraciones y declaraciones organizadas según diferentes situaciones de la vida.',
  image: images.botiquin,
  icon: 'heart'
}, {
  number: 5,
  title: '50 Tarjetas de Promesas Bíblicas',
  description: '50 tarjetas con promesas bíblicas para acompañar tu recorrido.',
  image: images.promesas,
  icon: 'cards'
}];
export const collection: CollectionItem[] = [{
  title: 'Desafío Mujer de Proverbios 31',
  kind: 'principal'
}, {
  title: 'Devocional de 31 días',
  kind: 'bono'
}, {
  title: 'Oraciones Diarias',
  kind: 'bono'
}, {
  title: 'Planificador de Mayordomía Cristiana — 142 páginas',
  kind: 'bono'
}, {
  title: 'Botiquín Espiritual',
  kind: 'bono'
}, {
  title: '50 Tarjetas de Promesas Bíblicas',
  kind: 'bono'
}];
export const growth = {
  line1: 'No estás llamada a ser perfecta.',
  line2: 'Estás llamada a crecer.',
  body: ['Proverbios 31 no tiene que convertirse en una lista imposible de expectativas.', 'Este desafío propone recorrer sus enseñanzas con calma, oración e intención.'],
  rhythm: ['Un día a la vez.', 'Una enseñanza a la vez.', 'Una pequeña acción a la vez.']
};
export const offerItems: string[] = ['Desafío práctico de 31 días', 'Devocional de 31 días', '31 oraciones guiadas', 'Planificador cristiano de 142 páginas', 'Botiquín Espiritual', '50 tarjetas de Promesas Bíblicas', 'Acceso digital'];
export const offerCta = 'QUIERO COMENZAR MIS 31 DÍAS';
export const faqs: Faq[] = [{
  question: '¿Es un producto físico?',
  answer: 'No. Es un producto digital.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'El acceso se entrega digitalmente después de completar la compra.'
}, {
  question: '¿Necesito imprimir los materiales?',
  answer: 'No necesariamente. Puedes utilizar los materiales de manera digital y, cuando corresponda, imprimirlos según tu preferencia.'
}, {
  question: '¿Necesito conocimientos bíblicos previos?',
  answer: 'No. El desafío está diseñado como un recorrido guiado para que puedas avanzar paso a paso.'
}, {
  question: '¿Cuánto dura el desafío?',
  answer: '31 días.'
}];
export const finalCta = {
  quote: 'Tu camino no empieza cuando te sientes lista.',
  quoteAccent: 'Empieza con una pequeña decisión.',
  description: '31 días para acercarte a Dios, llevar Su Palabra a tu vida y cultivar las virtudes de la mujer que Él te llamó a ser.',
  bundle: 'Todo el material + 5 bonos gratis',
  cta: 'QUIERO COMENZAR HOY'
};